import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
//import FMPText from './pureForm/FMPText';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/CheckCircle';
import { withStyles } from '@material-ui/core/styles';

import PricingRequestContainer from '../containers/retailPricing/PricingRequest';
import AuthUserContainer from '../containers/AuthUser';
import StationsContainer from '../containers/Stations';

import FormComponent from './FormComponent';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';

const styles = () => {
	return {
		check: {
			color: '#4CAF50',
			width: 20,
			height: 20,
			verticalAlign: 'middle',
			paddingRight: 5,
		},
	};
};

function SmsLabelValue(props) {
	return (
		<div style={{ textAlign: 'left' }}>
			<div style={{ fontSize: '12px', textTransform: 'uppercase', color: '#666' }}>
				{props.label}
			</div>
			<div style={{ fontSize: '18px' }}>{props.value}</div>
		</div>
	);
}

SmsLabelValue.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
};

class SendSmsPricingRequest extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			sent: false,
			isLookingUpStations: false,
			formFieldError: {},
			stationsWithSameNumber: undefined,
		};
	}

	componentDidMount() {
		const { station, showErrors } = this.props;

		if (!station.mobileNumberForSmsPricing) {
			this.setState({ stationsWithSameNumber: [] });
			return;
		}

		this.setState({ isLookingUpStations: true });
		this.props.searchStations({
			params: { mobileNumberForSmsPricing: station.mobileNumberForSmsPricing },
			callback: (err, r) => {
				console.log(r);
				this.setState({ isLookingUpStations: false });
				if (err) {
					return showErrors([err]);
				}
				if (_.isEmpty(r.collections.stationCollection)) {
					this.setState({ stationsWithSameNumber: [] });
					return;
				}

				console.log(r.collections.stationCollection, station);

				const stationsWithSameNumber = [];
				r.collections.stationCollection.forEach((s) => {
					if (s.stationId === station.stationId) {
						return;
					}
					stationsWithSameNumber.push(s);
				});
				this.setState({ stationsWithSameNumber });
			},
		});
	}

	handleSendPricingRequest = () => {
		const { station, showErrors, addPricingRequest } = this.props;
		const { stationsWithSameNumber } = this.state;
		//- Required fields
		const formFieldError = {};
		const errors = [];

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		const params = {};
		if (_.isEmpty(stationsWithSameNumber)) {
			params.stationId = station.stationId;
		} else {
			params.multiStationIds = [station.stationId];
			stationsWithSameNumber.forEach((s) => {
				params.multiStationIds.push(s.stationId);
			});
		}

		this.setState({ sent: true });
		this.state.sent = true;

		addPricingRequest({
			params,
			callback: (err) => {
				if (err) {
					this.state.sent = false;
				}
			},
		});
	};

	render() {
		const { station } = this.props;
		return (
			<Grid spacing={2} container style={{ alignItems: 'flex-start' }}>
				<Grid item xs={12} md={4}>
					<div style={{ display: 'flex', direction: 'row' }}>
						<div>
							<SmsLabelValue label="Station" value={`${station.number} - ${station.name}`} />
							<div style={{ height: 10 }} />
							<div style={{ display: 'flex' }}>
								<div style={{ paddingRight: 15, marginRight: 10, borderRight: '2px solid #ddd' }}>
									<SmsLabelValue
										label="Mobile Number"
										value={station.mobileNumberForSmsPricing || '*Empty*'}
									/>
									<div style={{ height: 10 }} />
									<SmsLabelValue
										label="Recipient Number"
										value={station.mobileNumberRecipient || '*Empty*'}
									/>
								</div>

								<Link
									to={`/station/update/${station.stationId}`}
									rel="noreferrer noopener"
									target="_blank"
									style={{ textDecoration: 'none', marginTop: 10, marginLeft: 7 }}
								>
									<Button size="small" variant="outlined">
										Update
									</Button>
								</Link>
							</div>
						</div>
					</div>
				</Grid>

				<Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
					<div
						style={{
							fontSize: '12px',
							textTransform: 'uppercase',
							color: '#666',
							paddingBottom: 2,
						}}
					>
						Stations sharing mobile number
					</div>

					{this.state.isLookingUpStations && <CircularProgress />}
					{this.state.stationsWithSameNumber && this.renderStationsWithSameNumber()}
				</Grid>

				<Grid item xs={12} md={4}>
					<Button
						variant="contained"
						color="primary"
						style={{ borderRadius: '30px', marginBottom: 5 }}
						onClick={this.handleSendPricingRequest}
						disabled={!station.mobileNumberForSmsPricing || this.state.sent}
					>
						Send SMS Pricing Request
					</Button>
					<div style={{ fontSize: '85%', color: '#666' }}>
						Note: Message will vary if its a single station or multi-site
					</div>

					{this.state.sent && (
						<p>
							<CheckIcon className={this.props.classes.check} />
							SMS Sent to Customer
						</p>
					)}
				</Grid>
			</Grid>
		);
	}

	renderStationsWithSameNumber = () => {
		const { stationsWithSameNumber } = this.state;
		if (_.isEmpty(stationsWithSameNumber)) {
			return <div>None shared</div>;
		}

		return stationsWithSameNumber.map((station) => {
			return (
				<div key={station.stationId}>
					{station.number} - {station.name}
				</div>
			);
		});
	};
}

SendSmsPricingRequest.propTypes = {
	station: PropTypes.object.isRequired,
	addPricingRequest: PropTypes.func.isRequired,
	searchStations: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
};

SendSmsPricingRequest.defaultProps = {};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	PricingRequestContainer,
	StationsContainer,
])(SendSmsPricingRequest);
